import design from '../models/design';

export default {
    create,
    defaultProperties,
    fromJSON,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function defaultProperties() {
    return {
        designs: [],
    };
}

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        designs: json._embedded.designs.map(design.fromJSON),
        designPageUrls: json._links.designPageUrls
            ? json._links.designPageUrls.map(link => link.href)
            : [],
        currentPageUrl: json._links.currentPageUrl ? json._links.currentPageUrl.href : undefined,
        designPageOffset: json.designPageOffset,
        totalDesignCount: json.totalDesignCount,
    };
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/models/designCollection.js